/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Update Verification Flow with Link Method
 */
export interface UpdateVerificationFlowWithLinkMethod { 
    /**
     * Sending the anti-csrf token is only required for browser login flows.
     */
    csrf_token?: string;
    /**
     * Email to Verify  Needs to be set when initiating the flow. If the email is a registered verification email, a verification link will be sent. If the email is not known, a email with details on what happened will be sent instead.  format: email
     */
    email: string;
    /**
     * Method is the method that should be used for this verification flow  Allowed values are `link` and `code` link VerificationStrategyLink code VerificationStrategyCode
     */
    method: UpdateVerificationFlowWithLinkMethod.MethodEnum;
    /**
     * Transient data to pass along to any webhooks
     */
    transient_payload?: object;
}
export namespace UpdateVerificationFlowWithLinkMethod {
    export type MethodEnum = 'link' | 'code';
    export const MethodEnum = {
        Link: 'link' as MethodEnum,
        Code: 'code' as MethodEnum
    };
}


